<template>
<v-content>
  <v-container fluid>
    <div id="content">
      <h2>{{ $route.name }}</h2>

      <section>
        <v-card flat>
          <v-card-title>
            <v-icon class="mr-2">fas fa-search</v-icon>
            <v-text-field v-model="listSearch" label="検索キーワード" single-line hide-details outlined dense></v-text-field>
            <v-spacer></v-spacer>
            <v-btn fab small color="primary" @click="dialog = true">
              <v-icon>fas fa-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-data-table
            :headers="columns"
            :items="desserts"
            :search="listSearch"
            sort-by="create_date"
            :sort-desc="true"
            mobile-breakpoint="800"
            class="row-enabled"
            @click:row="onRowClick">
            <template v-slot:item.price="props">
              {{ separate(props.item.price) }} 円
            </template>
          </v-data-table>
        </v-card>
      </section>

      <!-- 編集ダイアログ -->
      <v-dialog v-model="dialog" max-width="1000px" :scrollable="true" :persistent="true">
        <v-card>
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text class="scroll-content">
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="12" class="pa-2">
                  <v-text-field ref="maker" v-model="editedItem.maker">
                    <template v-slot:label>
                      <span class="required">メーカー</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field ref="name" v-model="editedItem.name" :rules="[rules.required]">
                    <template v-slot:label>
                      <span class="required">品名</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                  <v-text-field ref="model" v-model="editedItem.model" :rules="[rules.required]">
                    <template v-slot:label>
                      <span class="required">型式・型番</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                  <v-text-field ref="size" label="寸法・サイズ" v-model="editedItem.size"></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                  <v-text-field ref="price" v-model="editedItem.price" suffix="円" :rules="[rules.required, rules.number]">
                    <template v-slot:label>
                      <span class="required">仕切値</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                  <v-text-field ref="unit" v-model="editedItem.unit" :rules="[rules.required]">
                    <template v-slot:label>
                      <span class="required">単位</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-subheader>写真</v-subheader>
                  <Upload :files="editedItem.images" @lightbox="lightboxFunc" />
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-textarea ref="remarks" label="備考" v-model="editedItem.remarks" rows="3"></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="dialog-footer">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save" :loading="saving" :disabled="!valid">
              <v-icon left>fas fa-save</v-icon>登録
            </v-btn>
            <v-btn color="error" @click="deleteItem" :loading="saving" v-if="editedIndex > -1">
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="dialog = false">
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- lightboxダイアログ -->
      <v-dialog v-model="lightbox" max-width="600px">
        <v-img v-if="!!lightboxImage" :src="lightboxImage">
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </v-dialog>

    </div>
  </v-container>
</v-content>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import Upload from '@/components/Upload.vue'

export default {
  data() {
    return {
      valid: false,
      saving: false,
      dialog: false,
      desserts: [],
      listSearch: null,
      columns: [
        { text: 'メーカー', value: 'maker' },
        { text: '品名', value: 'name' },
        { text: '型式・型番', value: 'model' },
        { text: 'サイズ・寸法', value: 'size' },
        { text: '仕切値', value: 'price', align: 'end' },
        { text: '備考', value: 'remarks', width: 300 },
        { text: '登録日', value: 'create_date' },
      ],
      editedIndex: -1,
      editedItem: {
        images: [],
      },
      lightbox: false,
      lightboxImage: null,
    }
  },
  prop: {},
  mounted() {},
  created() {
    this.setLoading(true)
    let timer = setInterval(() => {
      if (this.getMyself()) {
        clearInterval(timer)
        this.init();
      }
    }, 100)
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? '商品の追加' : '商品の編集'
    },
    disabled() {
      return this.editedIndex !== -1 ? true : false
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    init() {
      const path = this
      //商品
      firebase.database().ref('items').on('child_added', (data) => {
        path.updateItem(data.key, data.val())
      })
      firebase.database().ref('items').on('child_changed', (data) => {
        path.updateItem(data.key, data.val())
      })
      firebase.database().ref('items').on('child_removed', (data) => {
        path.desserts = path.desserts.filter(e => e.id !== data.key)
      })
      this.setLoading(false)
    },
    updateItem(key, item) {
      let data = Object.assign({
        id: key,
        images: [],
      }, item)
      let origin = this.desserts.find(e => e.id === key)
      if (origin) {
        origin = Object.assign(origin, data)
      } else {
        this.desserts.push(data)
      }
    },
    //編集
    onRowClick(params) {
      this.editedIndex = this.desserts.findIndex(e => e.id === params.id)
      this.editedItem = Object.assign({}, params)
      this.dialog = true
    },
    //削除
    deleteItem() {
      const path = this
      if (confirm(path.editedItem.name + ' を削除しますか？')) {
        //削除
        firebase.database().ref('items/' + path.editedItem.id).set(null, function(error) {
          if (error) {
            this.myAlert('商品の削除に失敗しました')
          } else {
            path.log(path.getMyself().id, '商品の削除 = ' + path.editedItem.name + '[' + path.editedItem.model + ']')
            path.dialog = false
          }
        })
      }
    },
    close() {
      this.saving = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //保存
    save() {
      let validate = true
      Object.keys(this.$refs).forEach(f => {
        if (!this.$refs[f].validate(true)) validate = false
      })

      if (validate) {
        const path = this
        this.saving = true

        let data = Object.assign({}, this.editedItem)
        delete data.id
        Object.keys(data).forEach(f => {
          data[f] = data[f] || null
        })

        if (this.editedIndex > -1) {
          //更新日・更新者
          data.update_date = this.getNowStr()
          //更新
          firebase.database().ref('items/' + this.editedItem.id).update(data, function(error) {
            if (error) {
              this.myAlert('商品の更新に失敗しました')
            } else {
              path.log(path.getMyself().id, '商品を更新 = ' + data.name + '[' + data.model + ']')
              path.dialog = false
            }
          })

        } else {
          //登録日・更新者
          data.create_date = this.getNowStr()
          //追加
          let new_key = firebase.database().ref('parts').push().key
          firebase.database().ref('items/' + new_key).set(data, function(error) {
            if (error) {
              this.myAlert('商品の登録に失敗しました')
            } else {
              path.log(path.getMyself().id, '商品を追加 = ' + data.name + '[' + data.model + ']')
              path.dialog = false
            }
          })
        }
      }
    },
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        this.$refs[f].reset()
      })
      this.editedItem.images = []
      this.scrollReset()
    },
    scrollReset() {
      let container = document.getElementsByClassName('scroll-content')[0]
      container.scrollTop = 0
    },
    lightboxFunc(item) {
      this.lightbox = true
      this.lightboxImage = item.original
    },
  },
  components: {
    Upload,
  }
}
</script>

<style scoped>

</style>
